<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>门店信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card" style="margin-top:20px">

      <el-descriptions title="基本信息" :column="3" border>
        <el-descriptions-item label="名称：" label-class-name="my-label" content-class-name="my-content">{{addForm.name}}</el-descriptions-item>
        <el-descriptions-item label="性别：">{{addForm.sex==1?"男":(addForm.sex==0?'女':'')}}</el-descriptions-item>
        <el-descriptions-item label="身份证">{{addForm.id_code}}</el-descriptions-item>
        <el-descriptions-item label="联系电话：">
          <el-tag size="mini">{{addForm.mobile}}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="编码：" :contentStyle="{'text-align': 'right'}">{{addForm.sn}}</el-descriptions-item>
        <el-descriptions-item label="社保状况：" :contentStyle="{'text-align': 'right'}"></el-descriptions-item>
        <el-descriptions-item label="是否在建：" :contentStyle="{'text-align': 'right'}"></el-descriptions-item>
        <el-descriptions-item label="执业时间：" :contentStyle="{'text-align': 'right'}"></el-descriptions-item>
        <el-descriptions-item label="社保开始缴纳时间：" :contentStyle="{'text-align': 'right'}"></el-descriptions-item>
        <el-descriptions-item label="费用缴纳单位：" :contentStyle="{'text-align': 'right'}"></el-descriptions-item>
        <el-descriptions-item label="在公司注册成功时间：" :contentStyle="{'text-align': 'right'}"></el-descriptions-item>
        <el-descriptions-item label="转出时间：" :contentStyle="{'text-align': 'right'}"></el-descriptions-item>
        <el-descriptions-item label="创建人：" :contentStyle="{'text-align': 'right'}"></el-descriptions-item>
        <el-descriptions-item label="创建时间：" :contentStyle="{'text-align': 'right'}"></el-descriptions-item>
      </el-descriptions>
      <el-divider content-position="left">证书信息</el-divider>
      <el-table
        :data="creditList"
        border
        style="width: 100%">
        <el-table-column
          prop="date"
          label="序号"
          width="180">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip='true'
          prop="date"
          label="证书名称"
          width="180">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip='true'
          prop="name"
          label="证书编号"
          width="180">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip='true'
          prop="address"
          width="180"
          label="证书注册号">
        </el-table-column>
        <el-table-column
          prop="address"
          :show-overflow-tooltip='true'
          label="证书专业">
        </el-table-column>
        <el-table-column
          prop="address"
          :show-overflow-tooltip='true'
          width="180"
          label="取得时间">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip='true'
          prop="address"
          width="180"
          label="到期时间">
        </el-table-column>
        <el-table-column
          prop="address"
          :show-overflow-tooltip='true'
          label="证书预览">
        </el-table-column>
        <el-table-column
          prop="address"
          :show-overflow-tooltip='true'
          label="证书下载">
        </el-table-column>

      </el-table>




    </el-card>
  </div>
</template>
<script>


  import axios from 'axios'
  export default {
    components: {  },
    data() {
      return {
        employeeList:[],
        performanceList:[],
        creditList:[],
        tableData: [{
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }
        ],
        list:[{
          sku_name:'',
          sn:'',
          id: null,
          product_id: '',
          product_name: '',
          brandSort: null,
          type: null,
          unit_name: null,
          num: null,
          isEgdit: true,
          brand_name:'',
          brand_id:''
        }],
        baseUrl:'/api/',
        fileList:[],
        shopList:[],
        dicList:[],
        cateList:[],
        provinceList:[],
        access_token:sessionStorage.getItem('token'),
        company_id:sessionStorage.getItem('company_id'),
        addForm:{
          handed_other_name:'',
          handed_id:'',
          address:'',
          total_amount:'',
          payee_account:'',
          payee_name:'',
          credit_code:'',
          employee_id:'',
          type_id:'',
          cate_id:'',
          province_id:"",
          dic_id:'',
          amount:'',
          remark:'',
          order_time:'',
          summary:"",
          manager_name:'',
          unit_name:"",
          title:'',
          shop_id:'',

        },
        ruleForm:{
          url:'',
          start_time:"",
          ad_id:'',
          ad_name:'',
          ad_link:'',
          position_id:'',
          ad_code:''
        },
        cateMenus:[],
        editor: null,
        html: '<p>hello</p>',
        toolbarConfig: { },
        editorConfig: { placeholder: '请输入内容...',
          // 所有的菜单配置，都要在 MENU_CONF 属性下
          MENU_CONF: {
            //配置上传图片
            uploadImage: {
              customUpload: this.uploadImg
            }
          }
        },
        mode: 'default', // or 'simple'
        rules: {
          title:[
            { required: true, message: "请输入合同名称", trigger: 'change' }
          ],
          position_id:[
            { required: true, message: "请选择分类", trigger: 'change' }
          ],

        },
      }
    },
    mounted() {
      // 模拟 ajax 请求，异步渲染编辑器
      this.getCateMenus();

      var id= this.$route.query.id;
      if(!isNaN(id)&&id>0){
        this.addForm.id=id;
        this.getOne();
      }
      this.getDicList();
      this.getCateList();
      this.getProvinceList();
      this.getShopList();
      this.getEmployeeList();
    },
    methods: {
      addItem() {
        let item = {
          sku_name:'',
          sn:'',
          id: null,
          product_id: '',
          product_name: '',
          brandSort: null,
          type: null,
          unit_name: null,
          num: null,
          isEgdit: true,
          brand_name:'',
          brand_id:''
        }
        this.list.push(item)
      },
      getDicList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:"InvoiceType",
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            this.dicList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getCateList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:"InvoiceCate",
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            this.cateList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getEmployeeList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.employeeList(param).then(res=>{
          if(res.code == 200){
            this.employeeList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getProvinceList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          parent_id:1,
        }
        this.$axios.regionList(param).then(res=>{
          if(res.code == 200){
            this.provinceList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getShopList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),

        }
        this.$axios.shopList(param).then(res=>{
          if(res.code == 200){
            this.shopList =res.data;
            this.addForm.shop_id=res.data[0].id;
            this.DataList();
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },

      submitForm(){

        this.$refs.formForRef.validate((valid) => {
          if (valid) {
            let params=this.addForm;
            console.log('params------',params)

            this.$axios.constructionContractSave(params).then(res=>{
              if(res.code == 200){
                this.$message.success("保存成功");
                this.$router.push('/constructionContractList')
              }
            }).catch(error=>{
              this.$message.error("保存错误");
              console.log(error);
            })

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getOne(){
        let _this=this;
        let param={
          access_token: _this.access_token,
          company_id: _this.company_id,
          id:_this.addForm.id
        };
        this.$axios.shopOne(param).then((res)=>{
          if(res.code==200){
           _this.addForm=res.data;
            // if(_this.ruleForm.ad_code!=''&&_this.ruleForm.ad_code!=null){
            //   var img={
            //     name:_this.ruleForm.ad_name,
            //     url:_this.ruleForm.ad_code
            //   }
            //   _this.fileList.push(img);
           // }
          }
          console.log(res);
        });
      },
      uploadFile (item) {
        let _this=this;
        //let formData = new FormData()
        let file = item.raw;
        this.logoFile=item.raw;
        // formData.append('file', file);
        let param={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id')
        };
        this.$axios.getAliJson(param).then(res=>{
          let data = res['data'];
          console.log('aliyun',data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let host = data['host'];
          let request = new FormData();
          request.append('name', file.name);
          request.append("key", key + 'mrh/' + autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('aliyun5555',request);

          axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;

            _this.ruleForm.ad_code=fullurl;
            var img={
              name:_this.ruleForm.ad_name,
              url:_this.ruleForm.fullurl
            }
            _this.fileList.push(img);
          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )
        });

      },
      resetForm(formName){
        this.$refs[formName].resetFields();
      },
      handleBeforeUpload(file) {
        console.log(file);
      },
      uploadSuccess(){

      },
      handleIsopenSelect(){

      },

      getCateMenus(){
        let _this = this;
        let url= '/api/api/mall.Ad_read_lz/getAdPositionMenus';
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        axios.post(url,params).then((res)=>{
          if(res.data.code == 200) {
            _this.cateMenus=res.data.data;
          }
        });
        _this.submit=false;
      },
      uploadImg(file, insertFn){

        let _this=this;
        let param={
          access_token: sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        // console.log(file);
        this.$axios.getAliJson(param).then(res=>{
          console.log('ali_json------',res)

          let data=res['data'];
          console.log(data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let  host = data['host'];

          // let fParam=
          //  {
          //    name:file.name,
          //    key:key +'mrh/'+ autoname + suffix,
          //    policy:data['policy'],
          //    OSSAccessKeyId:data['accessid'],
          //    success_action_status:'200',
          //    callback:data['callback'],
          //    Signature:data['signature'],
          //    file:file
          //  };
          //
          //  qs.stringify(fParam)
          //{headers:{'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'}}

          let request = new FormData();
          request.append('name', file.name);
          request.append("key", key +'mrh/'+ autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('file=------',file)
          axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;
            setTimeout(function(){
              insertFn(fullurl); //插入地址
            },2000);


          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )
          // $.ajax({
          //   url: host,
          //   data: request,
          //   processData: false,//默认true，设置为 false，不需要进行序列化处理
          //   cache: false,//设置为false将不会从浏览器缓存中加载请求信息
          //   async: false,//发送同步请求
          //   contentType: false,//避免服务器不能正常解析文件---------具体的可以查下这些参数的含义
          //   // dataType: 'json',//不涉及跨域  写json即可
          //   type: 'post',
          //   success: function (callbackHost, request) { //callbackHost：success,request中就是 回调的一些信息，包括状态码什么的
          //     console.log(callbackHost);
          //     var fileurl = callbackHost.filename; //上传完成后的文件oss地址
          //     var fullurl=host+'/'+fileurl;
          //     var fileObj={
          //       'file_url':fullurl,
          //       'file_path':fileurl
          //     };
          //     console.log(fileObj);
          //     let tempList=vm.picList;
          //     console.log(tempList);
          //     tempList.push(fileObj);
          //    // vm.picList=tempList;
          //
          //     // $('#m-f-up').append("<li><a href='../images/demopic4.jpg'><img src='../images/demopic4.jpg' /></a><i  class='iconfont icon-weikaitong'></i></li>");
          //     //   $('#ad_code').val(fullurl);
          //     // $("#upload_img_icon img").attr('src',fullurl);
          //   },
          //   error: function(XMLHttpRequest, textStatus, errorThrown) {
          //     alert(XMLHttpRequest.status);
          //     alert(XMLHttpRequest.readyState);
          //     alert(textStatus);
          //   }
          // });
        });

        // let imgData = new FormData();
        // imgData.append('file', file);
        // console.log('lu-----------',file)
        // //调用上传图片接口，上传图片  我这里testUpImg是测试接口
        // testUpImg(imgData).then(response => {
        //   if(response.data.code == 0){
        //     //插入后端返回的url
        //     insertFn(response.data.data.url);
        //   }else{
        //   }
        // })
      },
      onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      },
      get_suffix(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      Ymdhis(){
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return ''+year+month+day+hour+minute+second;
      },
      urlParse(_url = '') {
        let url_obj = new URL(_url || window.location.href);
        let search_path = url_obj.search;
        let handle_path = decodeURIComponent(search_path.substr(1));

        let handle_path_arr = handle_path.split('&');
        let search_params = {};
        for(let item of handle_path_arr) {
          let r = item.split('=');
          search_params[r[0]] = r[1];
        }
        return {
          protpcol: url_obj.protocol,
          search: url_obj.search,
          host: url_obj.host,
          port: url_obj.port,
          pathname: url_obj.pathname,
          searchParams: search_params
        }
      },

    },

    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    },

  };
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
